import React from 'react';

import { Button, Modal } from 'antd';

import i18n from './../../utils/i18n';

const { confirm } = Modal;

var pjson = require('./../../../package.json');

const confirmText = {
  voyage_info_template_discard:
    'Soll der gesamte Entwurf mit allen Änderungen wirklich verworfen werden?'
};

const WIFooter = ({ location, history, showBackButton, buttons }) => {
  var saveEvent = location.state
    ? location.state.saveButton
      ? new Event(location.state.saveButton.event)
      : null
    : null;
  var saveAndBackEvent = location.state
    ? location.state.saveAndBackButton
      ? new Event(location.state.saveAndBackButton.event)
      : null
    : null;

  var saveAndPublishEvent = location.state
    ? location.state.saveAndPublishButton
      ? new Event(location.state.saveAndPublishButton.event)
      : null
    : null;
  var discardEvent = location.state
    ? location.state.discardButton
      ? new Event(location.state.discardButton.event)
      : null
    : null;

  function handleDiscardConfirm() {
    confirm({
      title: 'Änderungen verwerfen',
      content: confirmText[location.state.discardButton.event],
      okText: i18n.actions.discard,
      cancelText: i18n.actions.cancel,
      onOk() {
        window.dispatchEvent(discardEvent);
      },
      onCancel() {}
    });
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row'
      }}
    >
      <div
        style={{
          width: 256
        }}
      >
        World Insight {new Date().getFullYear()}
        <small> Version: {pjson.version}</small>
      </div>
      <div>
        {showBackButton ? (
          <Button
            aria-label={i18n.actions.back}
            title={i18n.actions.back}
            type="secondary"
            onClick={() => history.goBack({ state: { showBackButton: false } })}
          >
            {i18n.actions.back}
          </Button>
        ) : null}
      </div>
      <div style={{ marginLeft: 'auto', marginRight: 15 }}>
        {location.state ? (
          location.state.discardButton ? (
            <Button
              aria-label={i18n.actions.discard}
              title={i18n.actions.discard}
              type="dashed"
              icon="undo"
              onClick={() =>
                location.state.discardButton.event ===
                'voyage_info_template_discard'
                  ? handleDiscardConfirm()
                  : window.dispatchEvent(discardEvent)
              }
            >
              {i18n.actions.discard}
            </Button>
          ) : null
        ) : null}
      </div>

      <div style={{ marginRight: 15 }}>
        {location.state ? (
          location.state.saveButton ? (
            <Button
              aria-label={i18n.actions.save}
              title={i18n.actions.save}
              type="primary"
              icon="save"
              onClick={() => window.dispatchEvent(saveEvent)}
            >
              {i18n.actions.save}
            </Button>
          ) : null
        ) : null}
      </div>
      <div style={{ marginRight: 15 }}>
        {location.state ? (
          location.state.saveAndBackButton ? (
            <Button
              aria-label={i18n.actions.saveAndBack}
              title={i18n.actions.saveAndBack}
              type="secondary"
              icon="save"
              onClick={() => window.dispatchEvent(saveAndBackEvent)}
            >
              {i18n.actions.saveAndBack}
            </Button>
          ) : null
        ) : null}
      </div>

      <div style={{ marginRight: 15 }}>
        {location.state ? (
          location.state.saveAndPublishButton ? (
            <Button
              className="bg-success"
              aria-label={i18n.actions.saveAndPublish}
              title={i18n.actions.saveAndPublish}
              type="primary"
              icon="check-circle"
              loading={location.state.loading}
              onClick={() => window.dispatchEvent(saveAndPublishEvent)}
            >
              {i18n.actions.saveAndPublish}
            </Button>
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default WIFooter;



// WEBPACK FOOTER //
// ./src/components/WIFooter/index.js